// Library
import React, { Component } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from "react-router-dom";

// Local
import localization from "localization";

// Component
import Landing from "../processes/landing/container/landing-container";
import Payment from "../processes/payment/container/payment-container";
import ModalState from "../processes/modal-state";
import Yookassa from "../processes/yookassa/containers/test-kassa-container";

const langs = "(" + localization.possibleLangList.join("|") + ")";
const partRoute = process.env.PART_ROUTE;
class AppRoutes extends Component {
  //Создаем разметку
  render() {
    return (
      <Router>
        <Switch>
          <Route exact path="/">
            <Redirect
              to={`${partRoute}/${localization.selectedLang()}/landing`}
            />
          </Route>
          <Route
            exact
            path={partRoute + "/:lang" + langs + "/landing"}
            render={props => (
              <>
                <Landing />
                <ModalState />
              </>
            )}
          />
          <Route
            path={partRoute + "/:lang" + langs + "/payment/:productId/:id"}
            render={props => (
              <>
                <Payment {...props} />
                <ModalState />
              </>
            )}
          />
          <Route
            exact
            path={partRoute + "/kassa"}
            render={props => <Yookassa />}
          />
          <Route>
            <Redirect
              to={`${partRoute}/${localization.selectedLang()}/landing`}
            />
          </Route>
        </Switch>
      </Router>
    );
  }
}

export default AppRoutes;
